module.exports = __webpack_public_path__ + "public/SiteIcons/moreItineraryHover.svg?e2583cee";